/* Attempts describe an action, never a confirmed checkout or purchase. */
(function () {
  var names = ['checkout_attempt', 'checkout_blocked_backorder', 'checkout_blocked_bundle',
    'checkout_check_failed', 'backorder_acknowledged', 'backorder_ack_failed'];
  window.KKCheckoutDiagnostics = function (name, surface, reason) {
    var config = document.querySelector('[data-kk-cart-flow-config]');
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!config || config.dataset.diagnostics !== 'true' || names.indexOf(name) === -1) return;
    try {
      if (!privacy || privacy.analyticsProcessingAllowed() !== true) return;
      var data = { surface: ['page', 'drawer', 'link'].indexOf(surface) === -1 ? 'page' : surface };
      if (['network', 'timeout', 'response', 'changed', 'save', 'refresh'].indexOf(reason) !== -1) data.reason = reason;
      if (typeof window.clarity === 'function') window.clarity('event', 'kkumi_' + name);
      if (window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        Promise.resolve(window.Shopify.analytics.publish('kkumi_' + name, data)).catch(function () {});
      }
    } catch (_) { /* Diagnostics cannot interrupt checkout. */ }
  };
})();
